<template>
  <base-layout></base-layout>
</template>

<script>
import BaseLayout from '../Base'

export default {
  name: 'LayoutSimple',
  components: {
    BaseLayout
  },
}
</script>
